import { io } from "socket.io-client";

let baseUrl = process.env.REACT_APP_NODE_BASE_URL;

// Remove API path for Socket.IO
if (baseUrl?.includes("/api")) {
  baseUrl = baseUrl.split("/api")[0];
}

const socket = io(baseUrl, {
  autoConnect: false,
  withCredentials: true,

  // Use polling first, then upgrade to WebSocket
  transports: ["polling", "websocket"],

  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});

export default socket;